import { createContext, useContext, createSignal, JSX, ParentComponent } from 'solid-js';

export type Page = 'home' | 'blog' | 'blog-article' | 'cv';

interface NavigationContextType {
  currentPage: () => Page;
  currentArticleSlug: () => string | null;
  navigateToHome: () => void;
  navigateToBlog: () => void;
  navigateToArticle: (slug: string) => void;
  navigateToCV: () => void;
}

const NavigationContext = createContext<NavigationContextType>();

export const NavigationProvider: ParentComponent = (props) => {
  const [currentPage, setCurrentPage] = createSignal<Page>('blog');
  const [currentArticleSlug, setCurrentArticleSlug] = createSignal<string | null>(null);

  const navigateToHome = () => {
    setCurrentPage('home');
    setCurrentArticleSlug(null);
    window.scrollTo(0, 0);
  };

  const navigateToBlog = () => {
    setCurrentPage('blog');
    setCurrentArticleSlug(null);
    window.scrollTo(0, 0);
  };

  const navigateToArticle = (slug: string) => {
    console.log('NavigationContext.navigateToArticle called with slug:', slug);
    setCurrentPage('blog-article');
    setCurrentArticleSlug(slug);
    console.log('Page set to blog-article, slug set to:', slug);
    window.scrollTo(0, 0);
  };

  const navigateToCV = () => {
    setCurrentPage('cv');
    setCurrentArticleSlug(null);
    window.scrollTo(0, 0);
  };

  return (
    <NavigationContext.Provider
      value={{
        currentPage,
        currentArticleSlug,
        navigateToHome,
        navigateToBlog,
        navigateToArticle,
        navigateToCV,
      }}
    >
      {props.children}
    </NavigationContext.Provider>
  );
};

export const useNavigation = () => {
  const context = useContext(NavigationContext);
  if (!context) {
    throw new Error('useNavigation must be used within NavigationProvider');
  }
  return context;
};
